import { Injectable } from '@angular/core';
import { EventEmitter } from 'events';
import { Subject } from 'rxjs';

@Injectable()
export class EventsProvider {

  private resetDetalheCampanha = new Subject<any>();
  private subjectProcedimento = new Subject<any>();
  private subjectCidUpdate = new Subject<any>();
  private subjectCnesUpdate = new Subject<any>();
  private subjectModalidadeUpdate = new Subject<any>();
  private subjectProcedimentoUpdate = new Subject<any>();


  cidSearch(data: any) {
    this.resetDetalheCampanha.next(data);
  }

  observeCidSearch(): Subject<any> {
    return this.resetDetalheCampanha;
  }

  procedimentoSearch(data: any) {
    this.subjectProcedimento.next(data);
  }

  observeProcedimentoSearch(): Subject<any> {
    return this.subjectProcedimento;
  }

  listSelectUpdate(data: any) {
    this.subjectCidUpdate.next(data);
  }

  observelistSelectUpdate(): Subject<any> {
    return this.subjectCidUpdate;
  }

  cnesUpdate(data: any) {
    this.subjectCnesUpdate.next(data);
  }

  observeCnesUpdate(): Subject<any> {
    return this.subjectCnesUpdate;
  }

  modalidadeUpdate(data: any) {
    this.subjectModalidadeUpdate.next(data);
  }

  observeModalidadeUpdate(): Subject<any> {
    return this.subjectModalidadeUpdate;
  }

  procedimentoUpdate(data: any) {
    this.subjectProcedimentoUpdate.next(data);
  }

  observeProcedimentoUpdate(): Subject<any> {
    return this.subjectProcedimentoUpdate;
  }
}
